import 'materialize-css/dist/css/materialize.min.css';
import 'react-dates/lib/css/_datepicker.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import multi from 'redux-multi'

import App from './components/App';
import reducers from './reducers';

const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

const store = createStore(
  reducers,
  preloadedState,
  compose(
    applyMiddleware(reduxThunk),
    applyMiddleware(multi)
  )
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/index.js